import './app-header.scss';
import { LogOut } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import logo from '../../assets/image/logo/updated-logo.svg';
import { useEffect, useState } from 'react';
import { fetchOnboardingMe } from '../../services/auth';

export default function AppHeader({ title }) {
	const navigate = useNavigate();
	const [userDetails, setUserDetails] = useState('');

	const fetchUserDetails = async () => {
		try {
			const data = await fetchOnboardingMe();
			setUserDetails(data);
		} catch (error) {
			toast.error('Something went wrong while fetching user details!');
		}
	};

	useEffect(() => {
		fetchUserDetails();
	}, []);

	const onLogout = async () => {
		try {
			localStorage.clear();
			navigate('/');
		} catch (error) {
			toast.error('Something went wrong while logout!');
		}
	};

	return (
		<div className="app-header d-none d-md-block sticky-top">
			<div className="container-fluid px-3 px-xl-5">
				<div className="app-header__inner d-flex align-items-center justify-content-between position-relative py-2">
					<div className="d-flex align-items-center">
						<img
							onClick={() => navigate('/')}
							src={logo}
							alt="logo"
							className="app-header__logo img-fluid"
						/>
					</div>

					<div className="app-header__title-wrapper position-absolute start-50 translate-middle-x text-center">
						<span className="app-header__title">{title}</span>
					</div>

					<div className="d-flex align-items-center gap-2 gap-xl-5">
						{userDetails && (
							<span className="app-header__welcome">
								<span className="app-header__username">
									Welcome! {userDetails?.data?.first_name} {userDetails?.data?.last_name}
								</span>
							</span>
						)}

						<LogOut
							onClick={onLogout}
							size={20}
							strokeWidth={2}
							className="app-header__logout-icon"
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
